// Copyright (c) Ping. All rights reserved.

import type { Dispatch, SetStateAction } from 'react';

import { useOnboardingCoordinator } from './onboardingCoordinator';
import type { TourId } from './tourIds';
import { markTourSeen } from './tourTracking';

/**
 * The single dismissal path for a guided tour, shared by every exit:
 * Skip, Done, the close button, and a mask click. Frees the coordinator
 * slot for the next guide and closes the popover. For auto tours it also
 * marks the tour seen so it never returns; manual, on-demand tours (the
 * per-pane guide) pass `markSeen: false` since they are meant to be
 * re-openable.
 */
export function dismissTour(
  tourId: TourId,
  setIsOpen: Dispatch<SetStateAction<boolean>>,
  markSeen = true,
): void {
  if (markSeen) {
    void markTourSeen(tourId);
  }
  useOnboardingCoordinator.getState().release(tourId);
  setIsOpen(false);
}
